module.exports = __webpack_public_path__ + "media/venue/workshops@2x-bdb99c06.png";